// extracted by mini-css-extract-plugin
export default {"heroFrameAnimation":"HeroFrameAnimation__heroFrameAnimation-z0Ze","expandToFull":"HeroFrameAnimation__expandToFull-cfX8"};